import React, { useState } from 'react';
import styles from './DocumentationFilePicker.module.scss';
import DocumentationFilePickerItem from './DocumentationFilePickerItem';
import {
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import { useDiscourseContext } from '../../../Discourse/Services/DiscourseContext';
import InputButtonGroup from '../../../../Components/Base/InputButtonGroup/InputButtonGroup';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	onAdd: (file: DocumentationFile) => Promise<void>;
	onRemove: (file: DocumentationFile) => Promise<void>;
	folderId?: string;
	patientId: string;
}

const DocumentationFilePicker: React.FC<Props> = ({
	onAdd,
	onRemove,
	patientId,
	folderId,
}) => {
	const [filter, setFilter] = useState<string | undefined>(undefined);
	const { data, isLoading } = useDocumentationFilesQuery({
		folderId,
		userId: patientId,
		fulltext: filter,
	});

	const { discourseAttachments } = useDiscourseContext();

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<div className={styles.filter}>
					<InputButtonGroup
						placeholder={'base.enterNameOfFile'}
						onSearch={(fulltext: string) => setFilter(fulltext)}
					/>
					{!!filter && (
						<LinkButton
							onClick={() => setFilter(undefined)}
							title={'base.removeFilter'}
							theme={Theme.RED}
							className={styles.resetButton}
						/>
					)}
				</div>
			</div>
			{data?.documentationFiles?.data?.map(file => {
				return (
					<DocumentationFilePickerItem
						item={file as DocumentationFile}
						isAdded={
							discourseAttachments?.some(item => item.extra.id === file.id) ??
							false
						}
						key={file.id}
						onAdd={onAdd}
						onRemove={onRemove}
					/>
				);
			})}
		</div>
	);
};

export default DocumentationFilePicker;
